import React from "react";
import { outcomeCfg } from "./outcomeConfig";

export function OutcomeBadge({ cls }) {
  const cfg = outcomeCfg(cls);
  return (
    <span
      title={cls}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${cfg.bg} ${cfg.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
}
